import React, { useState, useContext, useEffect } from 'react';
import { addcontext } from '../../ContextShare/ContextShare';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import { AddConstituency, GetConstituency } from '../../Services/allApi';
import PopOver from '../../Components/PopOver';
import InfoIcon from '../../Components/InfoIcon'

function AddNewConstituency() {
    const { addConstituency, setaddConstituency } = useContext(addcontext)
    const [consttuencyData, setConsttuencyData] = useState({
        constituency_name: '',
        mal_constituency_name: '',
        constituency_no: '',
        constituency_description: ''

    });

    const [existingConstituency, setExistingConstituency] = useState([
        // { id: 1, name: 'Constituency 1' },
        // { id: 2, name: 'Constituency 2' },
        // { id: 3, name: 'Constituency 3' },

    ]);
    const [isConsAdded, setisConsAdded] = useState(true)

    const handleSave = async () => {
        if (consttuencyData?.constituency_name && consttuencyData?.constituency_no) {
            const token = sessionStorage.getItem('access_token')
            const reqHeader = {
                "Content-Type": "application/json",
                "Authorization": `${token}`
            };
            var datToApi
            if (consttuencyData.constituency_no) {
                datToApi = {
                    ...datToApi,
                    constituency_no: consttuencyData.constituency_no
                }
            }
            if (consttuencyData.mal_constituency_name) {
                datToApi = {
                    ...datToApi,
                    mal_constituency_name: consttuencyData.mal_constituency_name
                }
            }
            if (consttuencyData?.constituency_description) {
                datToApi = { ...datToApi, constituency_description: consttuencyData?.constituency_description }
            }
            //  else{
            datToApi = { ...datToApi, constituency_name: consttuencyData.constituency_name }
            //  }
            console.log(datToApi);
            const res = await AddConstituency(datToApi, reqHeader)
            // console.log(res);
            if (res?.status ==200) {
                toast.success("Constituency added successfully")
                setConsttuencyData({
                    constituency_name: '', mal_constituency_name: '',
                    constituency_no: '', constituency_description: ''
                })
                setisConsAdded(!isConsAdded)
                setaddConstituency(!addConstituency)
                
            }
            else {
                const messageData = res?.response?.data?.message;
                // Check if messageData is an object
                const errorMessage = typeof messageData === 'object' && messageData !== null
                    ? messageData[Object.keys(messageData)?.[0]]?.[0] // Get the first message from the object
                    : messageData; // If it's a string, use it directly
                toast.error(errorMessage ?? "There was a problem adding constituency");
            }
        }
        else {
            toast.warning("Enter constituency name and constituency number")
        }
    };

    const GetExistigConstituency = async () => {
        const result = await GetConstituency()
        console.log(result);
        const newConstList = result?.data?.data?.map((item) => (
            { id: item?.constituency_id, name: item?.constituency_name }
        ))
        setExistingConstituency(newConstList)
    }
    useEffect(() => {
        GetExistigConstituency()
    }, [isConsAdded])

    // const constiAddScript = () => {
    //     for (var i = 0; i <= 200; i++) {
    //         var newConst = {
    //             constituency_name: 'constituency' + i,
    //             constituency_no: i + 6,
    //         }
    //         callScriptApi(newConst)
    //     }
    // }
    // const callScriptApi = async (data) => {
    //     const token = sessionStorage.getItem('access_token')
    //     const reqHeader = {
    //         "Content-Type": "application/json",
    //         "Authorization": `${token}`
    //     };

    //     await AddConstituency(data, reqHeader)
    // }
    return (
        <>
            <div className='w-full flex items-center flex-col'>
                <h3 className='text-blue-700 text-xl font-bold mt-5 mb-5 text-center'>Enter Constituency Details</h3>
                {/* <button onClick={constiAddScript}>Execute script</button> */}
                <div className='flex flex-row justify-center flex-wrap mb-5 gap-3 w-full '>

                    <div className='w-3/12 flex flex-col'>
                        <label htmlFor="eventname" className='text-sm'>Name of the constituency</label>
                        <input
                            id='eventname'
                            // placeholder='Add new event'
                            value={consttuencyData.constituency_name}
                            onChange={(e) => setConsttuencyData({ ...consttuencyData, constituency_name: e.target.value })}
                            type="text"
                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        />
                    </div>

                    <div className='w-3/12 flex flex-col'>
                        <label htmlFor="eventname" className='text-sm'>Name of the constituency in malayalam</label>
                        <input
                            id='eventname'
                            // placeholder='Add new event'
                            value={consttuencyData.mal_constituency_name}
                            onChange={(e) => setConsttuencyData({ ...consttuencyData, mal_constituency_name: e.target.value })}
                            type="text"
                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        />
                    </div>

                    <div className='w-2/12 flex flex-col'>
                        <label htmlFor="eventname" className='flex flex-row gap-1 text-sm'><span>Constituency Number</span><InfoIcon content={'Constituency Number if the constitunecy has changed'} /></label>
                        <input
                            id='eventname'
                            // placeholder='Add new event'
                            value={consttuencyData.constituency_no}
                            onChange={(e) => setConsttuencyData({ ...consttuencyData, constituency_no: e.target.value })}
                            type="number"
                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        />
                    </div>

                    <div className='w-2/12 flex flex-col'>
                        <label htmlFor="desc" className='text-sm'>Constituency Description<span className='text-gray-500'>(Admin view)</span></label>
                        <input
                            id='desc'
                            // placeholder='Add new event'
                            value={consttuencyData.constituency_description}
                            onChange={(e) => setConsttuencyData({ ...consttuencyData, constituency_description: e.target.value })}
                            type="text"
                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        />
                    </div>


                </div>

                <br />
                <div className='w-2/12'>
                    <button className='w-full py-2 bg-primary text-white rounded-full' onClick={handleSave}>Save</button>
                </div>

                <div className='w-11/12 mt-10 border bg-success '>
                    <h4 className='text-blue-700 text-lg font-bold mb-5 mt-5 text-center'>Existing Constituency</h4>
                    <div className='flex flex-col items-center mb-5'>
                        {existingConstituency?.map(item => (
                            <div key={item.id} className='bg-white shadow-md rounded-lg px-4 py-2 mb-2 w-6/12 border border-gray-200'>
                                <div className='text-lg font-semibold'>{item.name}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            /> */}
        </>
    );
}

export default AddNewConstituency;
